import { formatForLabel } from 'features/siteMap/communalMapStyling/FormatForLabel'
import { StyledMapLabel } from 'features/siteMap/communalMapStyling/StyledMapLabel'
import { FC, ReactNode } from 'react'
import styled from 'styled-components'

import { PIN_SIZE } from './MarkerPinIcon'

const LabelDisplayContainer = styled.span`
  position: absolute;
  bottom: -${PIN_SIZE};
  transform: translate(-50%, -100%);
  height: min-content;
`
export const LabelDisplay: FC<{
  name: string
  extraLabelDisplay: ReactNode
}> = (props) => {
  return (
    <LabelDisplayContainer>
      <StyledMapLabel>
        {formatForLabel(props.name, props.extraLabelDisplay)}
      </StyledMapLabel>
    </LabelDisplayContainer>
  )
}
